import product1 from '../../images/product-1.jpg';
import product2 from '../../images/product-2.jpg';
import product3 from '../../images/product-3.jpg';
import SweetsOne from '../../images/sweets1.jpg';
import SweetsTwo from '../../images/sweets3.jpg';
import SweetsThree from '../../images/sweets2.jpg';

export const productData = [
  {
    img: product1,
    alt: 'Pizza',
    name: 'Supreme Pizza',
    desc: 'Sunday marinara, shortribs, basil, garlic and ricotta',
    price: '$21.99',
    button: 'Add to Cart',
  },

  {
    img: product2,
    alt: 'Pizza',
    name: 'White Widow',
    desc: 'White widow sauce, pesto, garlic, tomatoes, and ricotta',
    price: '$17.99',
    button: 'Add to Cart',
  },

  {
    img: product3,
    alt: 'Pizza',
    name: "Nonna's Favorite",
    desc: 'Sunday marinara, pepporoni, mushrooms, basil, and garlic',
    price: '$18.99',
    button: 'Add to Cart'
  }

];

export const productDataTwo = [
  {
    img: SweetsOne,
    alt: 'Dessert',
    name: 'Tiramisu',
    desc: 'Elegant and rich layerd italian classic.',
    price: '$8.99',
    button: 'Add to Cart',
  },

  {
    img: SweetsTwo,
    alt: 'Dessert',
    name: 'Cannoli cake',
    desc: 'Our take on a beloved italian pastry.',
    price: '$8.99',
    button: 'Add to Cart',
  },

  {
    img: SweetsThree,
    alt: 'Dessert',
    name: 'Lemonchelo cake',
    desc: 'Light, fluffy, Lemon and refreshing',
    price: '$8.99',
    button: 'Add to Cart'
  }

];
